import { SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import cr from "../../lib/request";
import ComponentSpinner from "../spinner/ComponentSpinner";
import { Course } from "../../const/types";
import CourseCard from "../card/CourseCard";
import useTrigger from "../../globalState/useTrigger";
import { Cookies } from "typescript-cookie";
import NoData from "../feedback/NoData";
import { useNavigate } from "react-router-dom";

export default function CourseList() {
  const [data, setData] = useState<Course[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { trigger } = useTrigger();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const userCookie = Cookies.get("user") as string;
    let url;
    if (userCookie) {
      url = `api/usercourse/courseauth`;
    } else {
      url = `api/usercourse/course`;
    }
    const payload = {
      limit: 48,
      offset: 0,
    };
    cr.post(url, payload)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
        Cookies.remove("user");
        navigate("/");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger, navigate]);

  return !loading && data && data.length > 0 ? (
    <SimpleGrid columns={[1, 2, 3, 4]} gap={4} spacingY={8}>
      {data.map((course, i) => (
        <CourseCard key={i} data={course} />
      ))}
    </SimpleGrid>
  ) : !loading && data && data.length === 0 ? (
    <NoData />
  ) : (
    <ComponentSpinner />
  );
}
